(function() {
    // Support browsers without document.currentScript (IE11)
    var currentScriptSrc = document.currentScript && document.currentScript.src ? document.currentScript.src : '';
    // RegEx to relatively find the host name to embed fingerprint script
    var hostNameRegex = currentScriptSrc.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
    // Default to 'assets.pixlee.com' when applicable
    var hostName = hostNameRegex && hostNameRegex[1] ? hostNameRegex[1] : 'assets.pixlee.com';
    // Use tracking domain if we are in production
    if (hostName.indexOf('.pxlecdn.com') !== -1) {
        hostName = 'assets.pixlee.com';
    }

    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://' + hostName + '/assets/fp.js';

    // If document.currentScript is unsupported, add the script to head instead
    if (document.currentScript) {
        document.currentScript.parentNode.insertBefore(s, document.currentScript);
    } else if (document.head) {
        document.head.appendChild(s);
    }

})();

(function() {
    var widget_iframes = {};
    var lightbox_iframe;
    var lightbox_options;
    var uploader_iframe;
    var social_auth_iframe;
    var variableName = '';
    //generates random integer 0-10
    var multivariateRandomNumber = parseInt(Math.random() * 10) + 1;

    //prevent multiple includes from messing things up. rootRoute prevents
    //control panel's 'Pixlee' object from breaking Design Editor
    if ('Pixlee' in window && window.Pixlee.rootRoute !== 'dashboard') {
        return false;
    }

    //this file always comes first for us so window.pixSentry can't already exist. Create a new instance and store it as
    //pixSentry on the window so that it can be shared by our other embedded scripts
    if (typeof Sentry !== 'undefined' &&
        Sentry.SDK_VERSION &&
        Sentry.SDK_VERSION.startsWith('6') &&
        typeof window.pixSentry === 'undefined'
    ) {
        // Since pixlee_widget.1.0.1.js is loaded directly onto the consumer page and not in an iframe,
        // the existence of sentry and its version is dependent on the consumer. We can try to initialize
        // it if possible, but if it doesn't work, we can just ignore it.
        // Upcoming Sentry v7 requires different parameters than our current v6 implementation and will fail here.
        // https://github.com/getsentry/sentry-javascript/blob/master/MIGRATION.md#explicit-client-options
        try {
            window.pixSentry = new Sentry.BrowserClient({
                dsn: 'https://f2c63857ff3d4d609f3011523e5933d5@sentry.io/12047',
                ignoreErrors: [/{\"name\":\"Error executing guarded function\",\"message\":\"Unable to get property \'origin\' of undefined or null reference\"}/, /{\"name\":\"Error executing guarded function\",\"message\":\"i is undefined\"}/, /widget url is undefined or empty/, /onMessage is not a function/, /The operation is insecure/, /is not a function \(evaluating/, /Unable to get property \'appendChild\' of undefined or null reference/, /currentAlbum is undefined/, /attempted to read protected variable/, /postMessage is not a function/, /Object doesn\'t support this property or method/, /FastClick is not defined/, /variable: FastClick/, /\$ is not defined/, /Cannot call method \"get\" of undefined/, /Cannot find function addEventListener in object/, /find variable: \$/, /but instead had type object/, /property or method \'postMessage\'/, /\'FastClick\' is undefined/, /NS_ERROR_FAILURE:/, /\'$\' is undefined/, /Access is denied/, /\'undefined\' is not a function/, /\'console\' is undefined/, /function miss failed/, /Invalid calling object/, /Out of memory/, /undefined is not an object/, /Error: Unspecified error/, /global jQuery object was not available/, /The operation was aborted/, /Illegal invocation/, /The play() request was interrupted by a call to pause()/, /The request is not allowed by the user agent or the platform in the current context/, /Non-Error promise rejection captured with/, /find variable: disableLegacyCookie/],
                denyUrls: [/pdp\.test/, /widget\.test/, /codepen/]
            });
        } catch (_e) {
            // Skipping initialization of pixSentry
        }
    }

    // Custom error type used when throwing internally
    var ManagedError = function(message) {
        Error.prototype.constructor.apply(this, arguments);
        this.message = message;
    };
    ManagedError.prototype = new Error();

    /**
     * Wraps a function so that it will never throw and bubble
     */
    function unguard(fn) {
        return function() {
            try {
                return fn.apply(this, arguments);
            } catch (e) {
                // surface the error
                // console.log(' - bubbling error to window.onerror');
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        };
    }
    var guid = (function() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return function() {
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                s4() + '-' + s4() + s4() + s4();
        };
    })();

    var isWidgetVisible = function(IframeNode) {
        if (!IframeNode) {
            return;
        }
        var widgetFrame = IframeNode;
        var vpWidth = window.innerWidth;
        var vpHeight = window.innerHeight;

        // Use this native browser method, if available.
        if (typeof widgetFrame.getBoundingClientRect === 'function') {
            var rec = widgetFrame.getBoundingClientRect();
            var hasSize = rec.top + rec.bottom + rec.left + rec.right;
            var tViz = rec.top >= 0 && rec.top < vpHeight;
            var bViz = rec.bottom > 0 && rec.bottom <= vpHeight;
            var lViz = rec.left >= 0 && rec.left < vpWidth;
            var rViz = rec.right > 0 && rec.right <= vpWidth;

            var vVisible = tViz || bViz;
            var hVisible = lViz || rViz;

            return hasSize && vVisible && hVisible;
        } else {
            //cross browser compatible offset calculations
            var viewTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
            var viewLeft = (window.pageXOffset !== undefined) ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;

            //simple math to get the bottom and right
            var viewBottom = viewTop + vpHeight;
            var viewRight = viewLeft + vpWidth;

            //get our final values
            var _top = widgetFrame.offsetTop;
            var _left = widgetFrame.offsetLeft;
            var _bottom = _top + widgetFrame.clientHeight;
            var _right = _left + widgetFrame.clientWidth;

            //check 'em
            return ((_top <= viewBottom) && (_bottom >= viewTop)) && ((_left <= viewRight) && (_right >= viewLeft));

        }
    };

    // Helper function for wrapping all functions

    function wrap(fn, value) {
        // not all 'function's are actually functions!
        if (typeof value === 'function' && /^function/.test(value.toString())) {
            return fn(value);
        } else if (typeof value === 'object' && value !== null) {
            for (var key in value) {
                if (value.hasOwnProperty(key)) {
                    value[key] = wrap(fn, value[key]);
                }
            }
        }
        return value;
    }

    /**
     * Wraps a function so that any error thrown is reported.
     * ManagedError's are disregarded and rethrown.
     */

    function guard(fn) {
        return function() {
            // capture the arguments and unguard any functions
            var args = Array.prototype.slice.call(arguments).map(wrap.bind(null, unguard));

            try {
                return wrap(guard, fn.apply(this, args));
            } catch (e) {
                // If this is a ManagedError, then this is something that we want to
                // surface without logging it
                if (e instanceof ManagedError) {
                    // console.log(' - Managed error: re-throw', e);
                    throw e;
                }
                // log error
                // console.log(' - Unmanaged error: log and re-throw', e);
                throw e;
            }
        };
    }

    var logError = function(exception, extraFields) {
        if (window.console) {
            console.log(exception);
        }
        if (typeof window.pixSentry !== 'undefined') {
            extraFields = extraFields || '';
            window.pixSentry.captureException(exception, {
                tags: {
                    source: 'Pixlee Widget 1.0.1'
                },
                extra: {
                    objectBody: extraFields
                }
            });
        }
    };

    function mobileCheck() {
        var isMobile = false;
        (function(a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
                isMobile = true;
            }
        })(navigator.userAgent || navigator.vendor || window.opera);
        return isMobile;
    }

    function tabletCheck() {
        var isTablet = false;
        (function(a) {
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(a)) {
                isTablet = true;
            }
        })(navigator.userAgent || navigator.vendor || window.opera);
        return isTablet;
    }

    function iOSSafariCheck() {
        var isIOSSafari = false;
        (function(a) {
            var iOS = !!a.match(/iPad/i) || !!a.match(/iPhone/i);
            var webkit = !!a.match(/WebKit/i);
            var iOSSafari = iOS && webkit && !a.match(/CriOS/i);
            if (iOSSafari) {
                isIOSSafari = true;
            }
        })(navigator.userAgent || navigator.vendor || window.opera);
        return isIOSSafari;
    }

    function iOSChromeCheck() {
        var isIOSChrome = false;
        (function(a) {
            isIOSChrome = a.match('CriOS');
        })(navigator.userAgent || navigator.vendor || window.opera);
        return isIOSChrome;
    }

    //remove the flicker-preventing background
    function removeFlickerScreen() {
        var tempBackground = document.getElementById('flickerBackground');
        if (tempBackground) {
            document.body.removeChild(tempBackground);
        }
    }

    //create a temporary white background to prevent the scrolling from causing a visual flicker
    function createFlickerScreen() {
        var tempBackground = document.getElementById('flickerBackground');
        if (!tempBackground) {
            tempBackground = document.createElement('div');
            tempBackground.setAttribute('id', 'flickerBackground');
            tempBackground.setAttribute('style', 'height:100%; width:100%; position:sticky; top:0; left:0; opacity:1; z-index:9999; background-color:white;');
            document.body.appendChild(tempBackground);
        }
    }

    function resizeWidget(fixedWidth) {
        var isOldIE = (navigator.userAgent.indexOf('MSIE') !== -1); // Detect IE10 and below
        var isNewIE = (!!window.MSInputMethodContext && !!document.documentMode); //hack to detect IE11
        //default height calculation to prevent flickering in <IE10 and no width resize on IE11 to prevent shrinking
        if (isOldIE || isNewIE) {
            PixleeiFrameResize({
                log: false, // Enable console logging
                enablePublicMethods: true, // Enable methods within iframe hosted page
                resizedCallback: _api.onResize,
                checkOrigin: false
            }, 'iframe[id*=pixlee]');
        } else {
            PixleeiFrameResize({
                log: false, // Enable console logging
                enablePublicMethods: true, // Enable methods within iframe hosted page
                resizedCallback: _api.onResize,
                heightCalculationMethod: 'min',
                checkOrigin: false,
                sizeWidth: fixedWidth ? false : true // if they requested fixedWidth, don't resize on width
            }, 'iframe[id*=pixlee]');
        }
    }

    function hasDirectWidgetLink() {
        var widgetId = _api.getParameterByName('pixlee_widget_id', document.location.href);
        //by priority, target is: given widget id OR first embed found
        var target = document.querySelector('[data-widget-id="' + widgetId + '"]') || document.querySelector('[id*=pixlee_widget]');

        if (widgetId && target) {
            var targetTop = typeof target.getBoundingClientRect === 'function' ? target.getBoundingClientRect().top : target.offsetTop;
            // scroll used to be tracked by document.body by default, but moved to documentElement recently (2017) for Blink.
            // for now this won't work with safari. read more here: https://bugs.chromium.org/p/chromium/issues/detail?id=157855
            api.scrollToWidget(document.documentElement, targetTop, 300);
            _api.changeUrl(_api.removeParam('pixlee_widget_id', document.location.href));
        }
    }

    function getExperimentUrl(url, experiment) {
        if (experiment) {
            return _api.addParam(url, 'experiment_group', experiment);
        } else if (_api.experimentState === 'group_known') {
            // Invariant: The cookie is null checked in the init function, where this experimentState property is set.
            const experimentCookie = _api.getCookie('experiment_' + _api.ApiKey);
            if (experimentCookie) {
                return _api.addParam(url, 'experiment_group', experimentCookie.group);
            } else {
                console.warn(
                    'Experiment cookie not found even though experimentState is set. ' +
                    'This could be a development error and should be reported to the Emplifi team.'
                );
                return url;
            }
        } else {
            return _api.addParam(url, 'random_number', multivariateRandomNumber);
        }
    }

    var _api = {
        provide: function(name, fn) {
            this[name] = guard(fn);
        },
        onResize: function(options) {
            if (options.iframe.style.visibility) {
                options.iframe.style.visibility = '';
            }

            //http://stackoverflow.com/questions/23083462/how-to-get-an-iframe-to-be-responsive-in-ios-safari
            if (options.iframe.width === '1px') {
                options.iframe.style.minWidth = '100%';
            }

            var launchUploader = _api.getParameterByName('pixlee_uploader', document.location.href);

            if (launchUploader) {
                _api.createLightboxUploader({
                    widgetId: launchUploader
                });
            }

            hasDirectWidgetLink();
        },
        //keep these in double quotes for deployment purposes
        defaults: {
            /*eslint-disable */
            containerId: "pixlee_container",
            setMetaTags: false,
            rootUrl: "https://photos.pixlee.co/widget",
            uploaderUrl: "https://photos.pixlee.co/uploader",
            lightboxRootUrl: "https://photos.pixlee.co/lightbox",
            socialAuthUrl: "https://photos.pixlee.co/social_auth",
            distilleryUrl: "https://distillery.pixlee.co/",
            iframeId: "pixlee_widget_iframe",
            lightboxId: "pixlee_lightbox_iframe",
            uploaderId: "pixlee_uploader",
            socialAuthId: "pixlee_social_auth"
            /*eslint-enable */
        },
        scrollLeftPosition: 0,
        scrollTopPosition: 0
    };

    _api.provide('getCookieHelper', function(c_name) {
        var i, x, y, ARRcookies = document.cookie.split(';');

        for (i = 0; i < ARRcookies.length; i++) {
            x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
            y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
            x = x.replace(/^\s+|\s+$/g, '');
            if (x == c_name) {
                return JSON.parse(decodeURIComponent(y));
            }
        }
        return null;
    });

    _api.provide('getCookie', function(c_name) {
        return _api.getCookieHelper(c_name) || _api.getCookieHelper(c_name + '_legacy');
    });

    _api.provide('addParam', function(url, param, value) {
        var a = document.createElement('a'),
            regex = /[?&]([^=]+)=([^&]*)/g;
        var params = {},
            match, str = [];
        a.href = url;
        value = value || '';
        while (match = regex.exec(a.search)) {
            if (param != match[1]) {
                str.push(match[1] + '=' + match[2]);
            }
        }
        str.push(encodeURIComponent(param) + '=' + encodeURIComponent(value));
        a.search = (a.search.substring(0, 1) == '?' ? '' : '?') + str.join('&');
        return a.href;
    });

    // This function is called directly to set the GDPR cookie
    _api.provide('setCookieWithoutPrivacyCheck', function(cookieName, value, exDays) {
        var expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + exDays);
        var cookieValue = encodeURIComponent(JSON.stringify(value)) +
            ((exDays === null) || (exDays === undefined) ? '' : ('; expires=' + expiryDate.toUTCString())) + ';' + ' path=/; domain=' + window.location.host.replace('www', '');
        document.cookie = cookieName + '=' + cookieValue + '; SameSite=None; Secure';
        if (!_api.disableLegacyCookie) {
            document.cookie = cookieName + '_legacy=' + cookieValue;
        }
    });

    _api.provide('setCookie', function(cookieName, value, exDays) {
        if (_api.doesUserAcceptCookies()) {
            _api.setCookieWithoutPrivacyCheck(cookieName, value, exDays);
        }
    });

    _api.provide('getParameterByName', function(name, url) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
            results = regex.exec(url);
        return (results === null) || (results === undefined) ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
    });
    _api.provide('removeParam', function(key, sourceURL) {
        var rtn = sourceURL.split('?')[0],
            param,
            params_arr = [],
            queryString = (sourceURL.indexOf('?') !== -1) ? sourceURL.split('?')[1] : '';
        if (queryString !== '') {
            params_arr = queryString.split('&');
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split('=')[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            if (params_arr.length > 0) {
                rtn = rtn + '?' + params_arr.join('&');
            }
        }
        return rtn;
    });
    _api.provide('changeUrl', function(url) {
        if (history.replaceState && window.location.href != url) {
            window.history.replaceState({
                path: url
            }, '', url);
        }
    });
    _api.provide('iframeErrorHandler', function(error) {
        document.getElementById('myIFrame').style.display = 'none';
        console.error('Error loading iframe contents: ' + error);
        return true;
    });
    _api.provide('updateURLParameter', function(url, param, paramVal) {
        var TheAnchor = null;
        var newAdditionalURL = '';
        var tempArray = url.split('?');
        var baseURL = tempArray[0];
        var additionalURL = tempArray[1];
        var temp = '';
        var tmpAnchor;
        var TheParams;
        if (additionalURL) {
            tmpAnchor = additionalURL.split('#');
            TheParams = tmpAnchor[0];
            TheAnchor = tmpAnchor[1];
            if (TheAnchor) {
                additionalURL = TheParams;
            }

            tempArray = additionalURL.split('&');

            for (var i = 0; i < tempArray.length; i++) {
                if (tempArray[i].split('=')[0] != param) {
                    newAdditionalURL += temp + tempArray[i];
                    temp = '&';
                }
            }
        } else {
            tmpAnchor = baseURL.split('#');
            TheParams = tmpAnchor[0];
            TheAnchor = tmpAnchor[1];

            if (TheParams) {
                baseURL = TheParams;
            }
        }

        if (TheAnchor) {
            paramVal += '#' + TheAnchor;
        }

        var rows_txt = temp + '' + param + '=' + paramVal;
        return baseURL + '?' + newAdditionalURL + rows_txt;
    });

    _api.provide('refreshWidgets', function() {
        // reload widgets on the page
        var pixleeFrames = document.querySelectorAll('[id*=' + _api.defaults.iframeId + ']');
        // reassigning src forces a page refresh
        for (var i = 0; i < pixleeFrames.length; i++) {
            pixleeFrames[i].src = pixleeFrames[i].src;
        }
    });

    _api.provide('setLightboxPhotoId', function(albumPhotoId) {
        // DOM needs to be fully loaded to manipulate the src value of an iFrame
        var stateCheck = setInterval(function() {
            if (document.readyState !== 'complete') {
                return;
            }
            clearInterval(stateCheck);

            // Grab the correct pixlee_album_photo_id from the parameters
            // EXAMPLE) "http://photos.pixlee.com/lightbox/363296652?widget_id=1349575&mobile=true&api_key=oUmM0uIiFOyAAtg6JKYd"
            var lightboxIframe = document.getElementById(_api.defaults.lightboxId);
            var lightboxSrc = lightboxIframe.src;

            // parse src with js URL API
            var lightboxUrl = new URL(lightboxSrc);

            // extract albumPhotoId ("363296652")
            var albumPhotoIdRegex = lightboxUrl.pathname.match(/\d+$/);
            var previousAlbumPhotoId = albumPhotoIdRegex ? albumPhotoIdRegex[0] : null;

            // Replace the previous album photo id in the lightbox src
            if (previousAlbumPhotoId) {
                lightboxIframe.src = lightboxSrc.replace(previousAlbumPhotoId, albumPhotoId);
            } else {
                // there is no album photo id to replace so add it after "lightbox/"
                lightboxIframe.src = lightboxSrc.replace('lightbox', 'lightbox/' + albumPhotoId);
            }

            // Refresh widgets on the page to rebind js and fix mobile iframe swapping browser bug
            _api.refreshWidgets();
        }, 100);
    });

    _api.provide('createLightboxContainer', function(options, photo_id) {
        if (typeof options.lightbox !== 'undefined' && !options.lightbox) {
            return;
        }
        //create the lightbox Iframe
        if (!document.querySelector('#' + _api.defaults.lightboxId)) {
            var lightboxIframe = document.createElement('iframe');
            lightboxIframe.id = _api.defaults.lightboxId;
            lightboxIframe.width = '100%';
            lightboxIframe.height = '100%';
            lightboxIframe.style.top = '0';
            lightboxIframe.style.left = '0';
            if (typeof I18n !== 'undefined' && typeof I18n.t !== 'undefined') {
                lightboxIframe.title = I18n.t('widget.titles.lightbox');
            } else {
                lightboxIframe.title = 'Shop customer photos with Pixlee';
            }
            lightboxIframe.style.bottom = '0';
            lightboxIframe.style.right = '0';
            lightboxIframe.style.padding = 0;
            lightboxIframe.style.margin = 0;
            lightboxIframe.style.position = 'fixed';
            lightboxIframe.style.zIndex = '2147483647';
            // lightboxIframe.style.visibility = 'hidden';
            lightboxIframe.style.display = 'none';
            lightboxIframe.frameBorder = '0';
            lightboxIframe.style.border = 'none';
            // lightboxIframe.style.backfaceVisibility = 'hidden';
            lightboxIframe.setAttribute('allowFullScreen', '');

            var lightboxRootUrl = (photo_id !== null && photo_id !== undefined) ? _api.defaults.lightboxRootUrl + '/' + photo_id : _api.defaults.lightboxRootUrl;
            var experiment = _api.getParameterByName('experiment_group', document.location.href);

            if (options.AB) {
                lightboxRootUrl = getExperimentUrl(lightboxRootUrl, experiment);
            }
            if (typeof options.widgetId === 'undefined') {
                if (options.displayOptionsId) {
                    lightboxRootUrl = _api.addParam(lightboxRootUrl, 'display_options_id', options.displayOptionsId);
                }
                if (options.accountId) {
                    lightboxRootUrl = _api.addParam(lightboxRootUrl, 'account_id', options.accountId);
                }
                if (options.type) {
                    lightboxRootUrl = _api.addParam(lightboxRootUrl, 'type', options.type);
                }
                if (options.recipeId) {
                    lightboxRootUrl = _api.addParam(lightboxRootUrl, 'recipe_id', options.recipeId);
                }
                if (options.albumId) {
                    lightboxRootUrl = _api.addParam(lightboxRootUrl, 'album_id', options.albumId);
                } else if (options.albumPhotoId) {
                    lightboxRootUrl = _api.addParam(lightboxRootUrl, 'album_photo_id', options.albumPhotoId);
                }
            } else {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'widget_id', options.widgetId);
            }

            if (options.skuId) {
                if (options.parent_category) {
                    lightboxRootUrl = _api.addParam(lightboxRootUrl, 'p_t_c_id', options.skuId);
                } else {
                    lightboxRootUrl = _api.addParam(lightboxRootUrl, 'product_id', options.skuId);
                }
            }
            if (options.skuOrCategories) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'sku_or_categories', options.skuOrCategories);
            }
            if (options.productName) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'product_name', options.productName);
            }
            if (options.categoryId) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'category_id', options.categoryId);
            }
            if (options.previewMode) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'previewMode', options.previewMode);
            }
            if (options.isFacebook) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'is_facebook', options.isFacebook);
            }
            if (options.categoryUrl) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'category_url', options.categoryUrl);
            }
            if (options.categoryName) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'category_name', options.categoryName);
            }
            if (options.insensitiveCategoryName) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'insensitive_category_name', options.insensitiveCategoryName);
            }
            if (options.nativeCategoryId) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'native_category_id', options.nativeCategoryId);
            }
            if (options.fallbackAlbumId) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'fallback_album_id', options.fallbackAlbumId);
            }
            if (options.fallbackThreshold) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'fallback_threshold', options.fallbackThreshold);
            }
            if (options.getCookieConsent) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'require_cookie_consent', options.getCookieConsent);
            }

            if (options.designEditorDevice && options.designEditorDevice !== 'desktop') {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'design_editor_device', options.designEditorDevice);
                lightboxIframe.className = options.designEditorDevice;
            }

            if (mobileCheck() && !options.designEditorDevice) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'mobile', true);
            } else if (tabletCheck() && !options.designEditorDevice) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'tablet', true);
            }
            if (_api.ApiKey) {
                lightboxRootUrl = _api.addParam(lightboxRootUrl, 'api_key', _api.ApiKey);
            }
            lightboxIframe.onerror = function(error) {
                _api.iframeErrorHandler(error, lightboxIframe.id);
            };
            lightboxIframe.onload = function(error) {
                if (options.onLightboxLoaded) {
                    options.onLightboxLoaded();
                }
            };

            var initiateIframe = function() {
                lightboxIframe.src = lightboxRootUrl;

                if (!_api.priority) {
                    document.body.appendChild(lightboxIframe);
                }
                lightbox_iframe = lightboxIframe;
                lightbox_options = options;
            };

            lightboxRootUrl = _api.addParam(lightboxRootUrl, 'parent_url', document.location.href.split(/[?#]/)[0]);
            //if it's a direct link, we want to make sure the distillery call will work (this is for multiple widgets)
            if (photo_id !== null) {
                var albumPhotoValidity = new XMLHttpRequest();
                albumPhotoValidity.onloadend = function() {
                    if (albumPhotoValidity.readyState === XMLHttpRequest.DONE || albumPhotoValidity.readyState === 4) {
                        //if the call will succeed, proceed as per usual
                        if (albumPhotoValidity.status >= 200 && albumPhotoValidity.status < 400) {
                            initiateIframe();
                        } else {
                            _api.createLightboxContainer(options, null);
                        }

                    }
                };
                lightbox_iframe = lightboxIframe;
                lightbox_options = options;
                //ping the url
                albumPhotoValidity.open('GET', lightboxRootUrl, true);
                albumPhotoValidity.send();
            } else {
                initiateIframe();
            }
        }
    });

    _api.provide('changeUserAgent', function(device) {
        navigator.__defineGetter__('userAgent', function() {
            return device;
        });
    });

    _api.provide('createLightboxUploader', function(options, photo_id) {
        /*
        Checks if options has a widgetId and usingKeyboard
        createLightboxUploader is used in multiple places:
         - should have just widgetId and usingKeyboard if called internally
         - should not be an object when called externally
        */
        if (typeof options === 'object' && typeof options.usingKeyboard !== 'undefined') {
            var frame = document.querySelector('iframe[src="' + options.widgetId + '"]');
            // usingKeyboard is for accessiblity purposes: tracking whether user is using keyboard/mouse
            var usingKeyboard = options.usingKeyboard;
            options = widget_iframes[frame.id].options;
            // Adding usingKeyboard back to options since it was replaced by widget_iframes[frame.id].options
            options.usingKeyboard = usingKeyboard;
        }

        //create the lightbox Iframe
        if (!document.querySelector('#' + _api.defaults.uploaderId)) {
            var uploaderFrame = document.createElement('iframe');
            uploaderFrame.id = _api.defaults.uploaderId;
            uploaderFrame.width = '100%';
            uploaderFrame.height = '100%';
            if (typeof I18n !== 'undefined' && typeof I18n.t !== 'undefined') {
                uploaderFrame.title = I18n.t('widget.titles.uploader');
            } else {
                uploaderFrame.title = 'Upload customer photos with Pixlee';
            }
            uploaderFrame.style.top = '0';
            uploaderFrame.style.left = '0';
            uploaderFrame.style.position = 'fixed';
            uploaderFrame.style.zIndex = '2147483647';
            uploaderFrame.style.visibility = 'hidden';
            uploaderFrame.frameBorder = '0';
            uploaderFrame.style.border = 'none';
            var uploaderRootUrl = _api.defaults.uploaderUrl;
            var experiment = _api.getParameterByName('experiment_group', document.location.href);

            if (options.AB) {
                uploaderRootUrl = getExperimentUrl(uploaderRootUrl, experiment);
            }
            if (mobileCheck()) {
                _api.pixleeMobileUploader = uploaderFrame;
                window.addEventListener('resize', _api.mobileUploaderResize);
            }
            if (typeof options.widgetId === 'undefined') {
                if (options.displayOptionsId) {
                    uploaderRootUrl = _api.addParam(uploaderRootUrl, 'display_options_id', options.displayOptionsId);
                }
                if (options.recipeId) {
                    uploaderRootUrl = _api.addParam(uploaderRootUrl, 'recipe_id', options.recipeId);
                }
                if (options.type) {
                    uploaderRootUrl = _api.addParam(uploaderRootUrl, 'type', options.type);
                } else {
                    uploaderRootUrl = _api.addParam(uploaderRootUrl, 'type', 'uploader');
                }
                if (options.accountId) {
                    uploaderRootUrl = _api.addParam(uploaderRootUrl, 'account_id', options.accountId);
                }
                if (options.albumId) {
                    uploaderRootUrl = _api.addParam(uploaderRootUrl, 'album_id', options.albumId);
                }
                if (options.albumPhotoId) {
                    uploaderRootUrl = _api.addParam(uploaderRootUrl, 'album_photo_id', options.albumPhotoId);
                }
            } else {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'widget_id', options.widgetId);
            }
            if (_api.ApiKey) {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'api_key', _api.ApiKey);
            }
            if (options.previewMode) {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'previewMode', options.previewMode);
            }
            if (options.skuId) {
                if (options.parent_category) {
                    uploaderRootUrl = _api.addParam(uploaderRootUrl, 'p_t_c_id', options.skuId);
                } else {
                    uploaderRootUrl = _api.addParam(uploaderRootUrl, 'product_id', options.skuId);
                }
            }
            if (options.productName) {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'product_name', options.productName);
            }
            if (options.skuOrCategories) {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'sku_or_categories', options.skuOrCategories);
            }
            if (options.nativeCategoryId) {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'native_category_id', options.nativeCategoryId);
            }
            if (options.categoryId) {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'category_id', options.categoryId);
            }
            if (options.categoryName) {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'category_name', options.categoryName);
            }
            if (options.insensitiveCategoryName) {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'insensitive_category_name', options.insensitiveCategoryName);
            }
            if (options.categoryUrl) {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'category_url', options.categoryUrl);
            }
            if (options.fallbackAlbumId) {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'fallback_album_id', options.fallbackAlbumId);
            }
            if (options.fallbackThreshold) {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'fallback_threshold', options.fallbackThreshold);
            }
            if (options.designEditorDevice && options.designEditorDevice !== 'desktop') {
                _api.changeUserAgent(options.designEditorDevice);
                uploaderFrame.className = options.designEditorDevice;
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'design_editor_device', options.designEditorDevice);
            }
            if (mobileCheck() && !options.designEditorDevice) {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'mobile', true);
            } else if (tabletCheck() && !options.designEditorDevice) {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'tablet', true);
            }
            // Type would be undefined if uploader was accessed through external api (usingKeyboard field would not exist)
            // usingKeyboard would be a boolean field if uploader was opened through 'Add to Photo' button
            if (typeof options.usingKeyboard === 'boolean') {
                uploaderRootUrl = _api.addParam(uploaderRootUrl, 'using_keyboard', options.usingKeyboard);
            }
            uploaderFrame.onerror = function(error) {
                _api.iframeErrorHandler(error, uploaderFrame.id);
            };

            // this is called after the backbone view has rendered
            uploaderFrame.onload = function() {

                uploaderFrame.style.visibility = '';

                if (options.onUploaderLoaded) {
                    options.onUploaderLoaded();
                }
                if (options.profile) {
                    api.setUploaderProfile(options.profile);
                }
            };

            // show uploader by attaching it to the DOM after the parent document's body
            uploaderFrame.src = uploaderRootUrl;
            document.body.appendChild(uploaderFrame);

            // must force focus onto the iframe before putting focus on any elements inside of element
            uploaderFrame.style.visibility = '';
            uploaderFrame.focus();

            setTimeout(function() {
                PixleeiFrameResize({
                    log: false, // Enable console logging
                    enablePublicMethods: true, // Enable methods within iframe hosted page
                    heightCalculationMethod: 'grow',
                    checkOrigin: false,
                    sizeWidth: true
                }, '#' + uploaderFrame.id);
            }, 0);
            uploader_iframe = uploaderFrame;
        }
    });

    _api.provide('createSocialAuth', function(options, photo_id) {
        //create the lightbox Iframe
        if (!document.querySelector('#' + _api.defaults.socialAuthId)) {
            var socialAuthFrame = document.createElement('iframe');
            socialAuthFrame.id = _api.defaults.socialAuthId;
            socialAuthFrame.width = '100%';
            socialAuthFrame.height = '100%';
            socialAuthFrame.style.top = '0';
            socialAuthFrame.style.left = '0';
            if (typeof I18n !== 'undefined' && typeof I18n.t !== 'undefined') {
                socialAuthFrame.title = I18n.t('widget.titles.share');
            } else {
                socialAuthFrame.title = 'Share customer photos with Pixlee';
            }
            socialAuthFrame.style.position = 'fixed';
            socialAuthFrame.style.zIndex = '2147483647';
            socialAuthFrame.style.visibility = 'hidden';
            socialAuthFrame.frameBorder = '0';
            socialAuthFrame.style.border = 'none';
            var socialAuthUrl = _api.defaults.socialAuthUrl;
            var experiment = _api.getParameterByName('experiment_group', document.location.href);

            if (options.AB) {
                socialAuthUrl = getExperimentUrl(socialAuthUrl, experiment);
            }
            if (typeof options.widgetId === 'undefined') {
                if (options.displayOptionsId) {
                    socialAuthUrl = _api.addParam(socialAuthUrl, 'display_options_id', options.displayOptionsId);
                }
                if (options.recipeId) {
                    socialAuthUrl = _api.addParam(socialAuthUrl, 'recipe_id', options.recipeId);
                }
                if (options.albumId) {
                    socialAuthUrl = _api.addParam(socialAuthUrl, 'album_id', options.albumId);
                }
                if (options.accountId) {
                    socialAuthUrl = _api.addParam(socialAuthUrl, 'account_id', options.accountId);
                }
                if (options.albumPhotoId) {
                    socialAuthUrl = _api.addParam(socialAuthUrl, 'album_photo_id', options.albumPhotoId);
                }
                if (options.type) {
                    socialAuthUrl = _api.addParam(socialAuthUrl, 'type', options.type);
                } else {
                    socialAuthUrl = _api.addParam(socialAuthUrl, 'type', 'social_auth');
                }
            } else {
                socialAuthUrl = _api.addParam(socialAuthUrl, 'widget_id', options.widgetId);
            }

            if (_api.ApiKey) {
                socialAuthUrl = _api.addParam(socialAuthUrl, 'api_key', _api.ApiKey);
            }
            if (options.previewMode) {
                socialAuthUrl = _api.addParam(socialAuthUrl, 'previewMode', options.previewMode);
            }
            if (options.skuId) {
                if (options.parent_category) {
                    socialAuthUrl = _api.addParam(socialAuthUrl, 'p_t_c_id', options.skuId);
                } else {
                    socialAuthUrl = _api.addParam(socialAuthUrl, 'product_id', options.skuId);
                }
            }
            if (options.productName) {
                socialAuthUrl = _api.addParam(socialAuthUrl, 'product_name', options.productName);
            }
            if (options.skuOrCategories) {
                socialAuthUrl = _api.addParam(socialAuthUrl, 'sku_or_categories', options.skuOrCategories);
            }
            if (options.nativeCategoryId) {
                socialAuthUrl = _api.addParam(socialAuthUrl, 'native_category_id', options.nativeCategoryId);
            }
            if (options.categoryId) {
                socialAuthUrl = _api.addParam(socialAuthUrl, 'category_id', options.categoryId);
            }
            if (options.categoryName) {
                socialAuthUrl = _api.addParam(socialAuthUrl, 'category_name', options.categoryName);
            }
            if (options.insensitiveCategoryName) {
                socialAuthUrl = _api.addParam(socialAuthUrl, 'insensitive_category_name', options.insensitiveCategoryName);
            }
            if (options.categoryUrl) {
                socialAuthUrl = _api.addParam(socialAuthUrl, 'category_url', options.categoryUrl);
            }
            if (options.fallbackAlbumId) {
                socialAuthUrl = _api.addParam(socialAuthUrl, 'fallback_album_id', options.fallbackAlbumId);
            }
            if (options.fallbackThreshold) {
                socialAuthUrl = _api.addParam(socialAuthUrl, 'fallback_threshold', options.fallbackThreshold);
            }

            if (options.designEditorDevice && options.designEditorDevice !== 'desktop') {
                _api.changeUserAgent(options.designEditorDevice);
                socialAuthFrame.className = options.designEditorDevice;
                socialAuthUrl = _api.addParam(socialAuthUrl, 'design_editor_device', options.designEditorDevice);
            }
            if (mobileCheck() && !options.designEditorDevice) {
                socialAuthUrl = _api.addParam(socialAuthUrl, 'mobile', true);
            } else if (tabletCheck() && !options.designEditorDevice) {
                socialAuthUrl = _api.addParam(socialAuthUrl, 'tablet', true);
            }

            socialAuthFrame.onerror = function(error) {
                _api.iframeErrorHandler(error, socialAuthFrame.id);
            };
            socialAuthFrame.onload = function() {
                socialAuthFrame.style.visibility = '';
                PixleeiFrameResize({
                    log: true, // Enable console logging
                    enablePublicMethods: true, // Enable methods within iframe hosted page
                    heightCalculationMethod: 'grow',
                    checkOrigin: false,
                    sizeWidth: true
                });
            };
            socialAuthFrame.src = socialAuthUrl;
            document.body.appendChild(socialAuthFrame);
            social_auth_iframe = socialAuthFrame;
        }
    });

    _api.provide('tagByEmail', function() {
        if (window.location.href.indexOf('pixlee_source=email') !== -1) {
            if ((window[variableName] && window[variableName].taggedByEmail) || (window.PixleeTrackingPixel && window.PixleeTrackingPixel.taggedByEmail)) {
                return;
            }
            var message = {
                name: 'pixlee:tag:by:email',
                data: {
                    windowLocationHref: window.location.href,
                    currentPixleeUserId: _api.getCookie('pixlee_analytics_cookie').CURRENT_PIXLEE_USER_ID,
                    apiKey: _api.ApiKey
                },
                destination: 'all',
                source: 'parent',
                type: 'relay'
            };
            sendMessage(message);
            api.taggedByEmail = true;
        }
    });

    _api.provide('createCookie', function(args) {
        var cookie = _api.getCookie('pixlee_analytics_cookie');
        if (!cookie) {
            var ob = {};
            ob.CURRENT_PIXLEE_USER_ID = args.distinct_user_hash;
            _api.setCookie('pixlee_analytics_cookie', ob, args.attribution_window);
        }
    });

    var init_cookie_try = false;

    _api.provide('openedPhoto', function(args) {
        var cookie = _api.getCookie('pixlee_analytics_cookie');
        if (cookie) {
            _api.setCookie('pixlee_analytics_cookie', cookie, args.attribution_window);
        } else if (!init_cookie_try) {
            init_cookie_try = true;
            _api.createCookie(args);
            _api.openedPhoto(args);
        }
    });

    _api.provide('interacted', function(args) {
        var cookie = _api.getCookie('pixlee_analytics_cookie');
        if (cookie) {
            _api.setCookie('pixlee_analytics_cookie', cookie, args.attribution_window);
        } else if (!init_cookie_try) {
            init_cookie_try = true;
            _api.createCookie(args);
            _api.interacted(args);
        }
    });

    _api.provide('doesUserAcceptCookies', function() {
        if (!_api.getCookieConsent) {
            // If getCookieConsent is not set, then this widget is not looking for the cookie consent, and cookies can be used
            return true;
        }
        var userConsent = _api.getCookie('EU_COOKIE_LAW_CONSENT');
        if (userConsent === null) {
            // If the cookie is not yet set, assume consent is not given
            return false;
        }
        return userConsent;
    });


    var api = {
        provide: function(name, fn) {
            this[name] = guard(fn);
        }
    };

    // Function that calls an external function
    api.provide('callCallback', function(callback) {
        callback();
    });

    // Function that throws without it being logged
    api.provide('throwManaged', function(num) {
        if (typeof num !== 'number') {
            throw new ManagedError('Invalid argument');
        }
    });
    api.provide('openUploader', function(options) {
        _api.createLightboxUploader(options);
    });
    api.provide('addSimpleWidget', function(options) {
        var url;
        if (options.albumId) {
            url = _api.addParam(_api.defaults.rootUrl, 'album_id', options.albumId);
        } else if (options.albumPhotoId) {
            url = _api.addParam(_api.defaults.rootUrl, 'album_photo_id', options.albumPhotoId);
        } else if (options.widgetId) {
            url = _api.addParam(_api.defaults.rootUrl, 'widget_id', options.widgetId);
        }

        options.iframe_src = url;
        _api.addWidget(options);
    });
    api.provide('addProductWidget', function(options) {
        var url;
        if (options.ecomm_platform && options.ecomm_platform === 'shopify') {
            var params = {};
            params.api_key = _api.ApiKey;
            var route = window.location.pathname.replace(/\/$/, '').split('/');
            var productHandle = route[route.length - 1];

            var getProductSKU = new XMLHttpRequest();
            getProductSKU.onreadystatechange = function() {
                if (getProductSKU.readyState === XMLHttpRequest.DONE || getProductSKU.readyState === 4) {
                    if (getProductSKU.status >= 200 && getProductSKU.status < 400) {
                        options.skuId = JSON.parse(getProductSKU.responseText).sku;
                        if (options.parent_category) {
                            url = _api.addParam(_api.defaults.rootUrl, 'p_t_c_id', options.skuId);
                        } else {
                            url = _api.addParam(_api.defaults.rootUrl, 'product_id', options.skuId);
                        }

                        if (options.widgetId) {
                            url = _api.addParam(url, 'widget_id', options.widgetId);
                        }
                        options.iframe_src = url;

                        _api.addWidget(options);
                        resizeWidget();
                    } else {
                        console.log('Call to Distillery failed. Status Code ' + getProductSKU.status);
                    }
                }
            };

            var callToDistillery = _api.defaults.distilleryUrl + '/api/v1/accounts/' + options.accountId + '/get_shopify_sku?';
            callToDistillery = callToDistillery + 'api_key=' + params.api_key;
            callToDistillery = callToDistillery + '&handle=' + productHandle;
            getProductSKU.open('GET', callToDistillery, true);
            getProductSKU.setRequestHeader('X-Alt-Referer', 'photos.pixlee.com');
            getProductSKU.send();

            _api.ecomm_platform = options.ecomm_platform;
        } else if (options.ecomm_platform && options.ecomm_platform === 'bigcommerce') {
            url = window.location.pathname;
            //remove trailing slash
            url = url.replace(/\/$/, '');
            var getProductSKU = new XMLHttpRequest();
            getProductSKU.onreadystatechange = function() {
                if (getProductSKU.readyState === XMLHttpRequest.DONE || getProductSKU.readyState === 4) {
                    if (getProductSKU.status >= 200 && getProductSKU.status < 400) {
                        options.skuId = JSON.parse(getProductSKU.responseText).sku;
                        url = _api.addParam(_api.defaults.rootUrl, 'product_id', options.skuId);
                        if (options.widgetId) {
                            url = _api.addParam(url, 'widget_id', options.widgetId);
                        }
                        options.iframe_src = url;

                        _api.addWidget(options);
                        resizeWidget();
                    } else {
                        console.log('Call to Distillery failed. Status Code ' + getProductSKU.status);
                    }
                }
            };
            var calltoDistillery = _api.defaults.distilleryUrl + '/api/v1/accounts/' + options.accountId + '/get_bigcommerce_sku';
            calltoDistillery = calltoDistillery + '?product_url=' + url;
            calltoDistillery = calltoDistillery + '&api_key=' + _api.ApiKey;

            getProductSKU.open('GET', calltoDistillery, true);
            getProductSKU.setRequestHeader('X-Alt-Referer', 'photos.pixlee.com');
            getProductSKU.send();
        } else {
            if (options.widgetId) {
                url = _api.addParam(_api.defaults.rootUrl, 'widget_id', options.widgetId);
                if (options.parent_category) {
                    url = _api.addParam(url, 'p_t_c_id', options.skuId);
                } else if (options.productName) {
                    url = _api.addParam(url, 'product_name', options.productName);
                } else {
                    url = _api.addParam(url, 'product_id', options.skuId);
                }
            } else if (options.skuId) {
                url = _api.addParam(_api.defaults.rootUrl, 'product_id', options.skuId);
            } else if (options.skuOrCategories) {
                url = _api.addParam(_api.defaults.rootUrl, 'sku_or_categories', options.skuOrCategories);
            } else if (options.productName) {
                url = _api.addParam(_api.defaults.rootUrl, 'product_name', options.productName);
            }

            options.iframe_src = url;
            _api.addWidget(options);
        }
    });

    api.provide('addCategoryWidget', function(options) {
        var url = _api.addParam(_api.defaults.rootUrl, 'widget_id', options.widgetId);
        if (options.ecomm_platform && options.ecomm_platform === 'bigcommerce' || options.categoryByUrl) {
            var categoryUrl = window.location.pathname;
            options.categoryUrl = categoryUrl;
            url = _api.addParam(url, 'category_url', options.categoryUrl);
        } else if (options.nativeCategoryId) {
            url = _api.addParam(url, 'native_category_id', options.nativeCategoryId);
        } else if (options.categoryName) {
            url = _api.addParam(url, 'category_name', options.categoryName);
        } else if (options.insensitiveCategoryName) {
            url = _api.addParam(url, 'insensitive_category_name', options.insensitiveCategoryName);
        } else {
            url = _api.addParam(url, 'category_id', options.categoryId);
        }
        options.iframe_src = url;
        _api.addWidget(options);
    });
    _api.provide('initMeta', function(options) {
        var headID = document.getElementsByTagName('head')[0];
        var metaNode = document.createElement('meta');
        metaNode.name = 'viewport';
        metaNode.content = 'width=device-width,initial-scale=1';
        metaNode.id = 'metatag';
        headID.appendChild(metaNode);
    });


    api.provide('close', function(single_page_app) {
        for (var key in widget_iframes) {
            var frame = widget_iframes[key].iframe;
            if (frame && frame.parentNode) {
                frame.parentNode.removeChild(frame);
            }
        }
        widget_iframes = {};
        if (uploader_iframe && uploader_iframe.parentNode) {
            uploader_iframe.parentNode.removeChild(uploader_iframe);
        }
        if (lightbox_iframe && lightbox_iframe.parentNode) {
            lightbox_iframe.parentNode.removeChild(lightbox_iframe);
        }
        if (!single_page_app) {
            window.removeEventListener('message', receiveMessage);
        }

        //remove powered by when we "close" the widget
        var poweredBy = document.querySelector('[id*="powered_by_pixlee"]');

        if (poweredBy && _api.mutationObserverPoweredBy) {
            poweredBy.removeEventListener('DOMNodeRemoved', _api.mutationObserverPoweredBy);
            poweredBy.parentNode.removeChild(poweredBy);
        }

        _api.changeUrl(_api.removeParam('pixlee_album_photo_id', window.location.href));
    });

    _api.provide('addWidget', function(options) {
        var url = options.iframe_src;

        if (options.setMetaTags) {
            _api.initMeta();
        }

        var photo_id = _api.getParameterByName('pixlee_album_photo_id', document.location.href);
        var initialFilters = _api.getParameterByName('pixlee_filters', document.location.href);
        var experiment = _api.getParameterByName('experiment_group', document.location.href);

        // If options.getCookieConsent is not a boolean, it is ignored
        _api.getCookieConsent = options.getCookieConsent;

        //this should never be used unless for emergencies as it is incomplete and will cause missing subset of analytics
        _api.disableLegacyCookie = options.disableLegacyCookie;

        if (options.AB) {
            url = getExperimentUrl(url, experiment);
        }
        if (!options.lightboxOff) {
            _api.createLightboxContainer(options, photo_id);
        }
        if (initialFilters) {
            url = _api.addParam(url, 'filters', initialFilters);
        }
        if (options.display_options) {
            url = _api.addParam(url, 'display_options', options.display_options);
        }
        if (options.recipe) {
            url = _api.addParam(url, 'recipe', options.recipe);
        }
        if (options.previewMode) {
            url = _api.addParam(url, 'previewMode', options.previewMode);
        }
        if (options.isFacebook) {
            url = _api.addParam(url, 'is_facebook', options.isFacebook);
        }
        if (typeof options.lightbox !== 'undefined' && !options.lightbox) {
            url = _api.addParam(url, 'show_lightbox', 'false');
        }
        if (options.categoryUrl) {
            url = _api.addParam(url, 'category_url', options.categoryUrl);
        }
        if (options.categoryName) {
            url = _api.addParam(url, 'category_name', options.categoryName);
        }
        if (options.insensitiveCategoryName) {
            url = _api.addParam(url, 'insensitive_category_name', options.insensitiveCategoryName);
        }
        if (options.nativeCategoryId) {
            url = _api.addParam(url, 'native_category_id', options.nativeCategoryId);
        }
        if (options.fallbackAlbumId) {
            url = _api.addParam(url, 'fallback_album_id', options.fallbackAlbumId);
        }
        if (options.fallbackThreshold) {
            url = _api.addParam(url, 'fallback_threshold', options.fallbackThreshold);
        }
        if (options.getCookieConsent) {
            url = _api.addParam(url, 'require_cookie_consent', options.getCookieConsent);
        }

        if (options.denyCookies === true) {
            api.denyCookiePolicy();
        } else if (options.denyCookies === false) {
            api.acceptCookiePolicy();
        }

        //if they have subscribed to our events, map internal names to external
        if (options.subscribedEvents) {
            _api.eventMappings = {
                'photoOpened': 'pixlee:open:lightbox',
                'photoClosed': 'pixlee:hide:lightbox',
                'photoChanged': 'pixlee:change:lightbox:image',
                'ctaClicked': 'pixlee:cta:clicked',
                'ctaChanged': 'pixlee:cta:changed',
                'widgetLoaded': 'pixlee:widget:loaded',
                'widgetNumPhotos': 'pixlee:widget:num:photos',
                'widgetNavigated': 'pixlee:widget:navigated',
                'widgetLoadMore': 'pixlee:widget:load:more',
                'uploadComplete': 'pixlee:upload:complete',
                'uploaderOpened': 'pixlee:uploader:open',
                'socialShare': 'pixlee:social:share',
                'widgetHidden': 'pixlee:hide:widget'
            };

            _api.subscribedEvents = options.subscribedEvents.map(function(evt) {
                return _api.eventMappings[evt] || '';
            });
        }

        if (_api.ApiKey) {
            url = _api.addParam(url, 'api_key', _api.ApiKey);
        }
        if (typeof options.widgetId === 'undefined') {
            if (options.type) {
                url = _api.addParam(url, 'type', options.type);
            }
            if (options.recipeId) {
                url = _api.addParam(url, 'recipe_id', options.recipeId);
            }
            if (options.displayOptionsId) {
                url = _api.addParam(url, 'display_options_id', options.displayOptionsId);
            }
            if (options.accountId) {
                url = _api.addParam(url, 'account_id', options.accountId);
            }
        }

        url = _api.addParam(url, 'parent_url', document.location.href);

        if (options.designEditorDevice && options.designEditorDevice !== 'desktop') {
            url = _api.addParam(url, 'design_editor_device', options.designEditorDevice);
        }

        if (mobileCheck() && !options.designEditorDevice) {
            url = _api.addParam(url, 'mobile', true);
        } else if (tabletCheck() && !options.designEditorDevice) {
            url = _api.addParam(url, 'tablet', true);
        }

        var iOS = /iPad|iPhone|iPod/.test(navigator.platform);
        var standalone = document.location.href.indexOf('standalone') !== -1;

        var container = document.getElementById(options.containerId || _api.defaults.containerId);
        if (container) {
            if (container.style.display == 'none') {
                url = _api.addParam(url, 'displayed', 'none');
            }
        }
        options.iframeId = _api.defaults.iframeId + guid();
        options.iframe_src = url;
        options.containerId = options.containerId || _api.defaults.containerId;
        var newIframe = document.createElement('iframe');
        newIframe.id = options.iframeId;
        newIframe.style.height = '0px';

        if (iOS && !standalone && options.type !== 'tap2shop' && options.type !== 'photowall' && options.type !== 'mosaic' && options.type !== 'mosaic_v2' && options.type !== 'single') {
            newIframe.width = '1px';
        } else {
            newIframe.width = '100%';
        }

        newIframe.style.visibility = _api.priority ? 'hidden' : '';
        newIframe.frameBorder = '0';
        newIframe.style.border = 'none';
        if (typeof I18n !== 'undefined' && typeof I18n.t !== 'undefined') {
            newIframe.title = I18n.t('widget.titles.gallery');
        } else {
            newIframe.title = 'Customer Photo gallery powered by Emplifi';
        }
        newIframe.setAttribute('allowFullScreen', '');
        newIframe.setAttribute('data-widget-id', options.widgetId || '1'); //old embeds will just get a 1 for consistency
        newIframe.onerror = function(error) {
            _api.iframeErrorHandler(error, newIframe.id);
        };
        newIframe.onload = function() {
            if (options.onWidgetLoaded) {
                options.onWidgetLoaded();
            }

            var msg;
            var data = {};
            if (options.subscribedEvents && options.subscribedEvents.indexOf('widgetLoaded') >= 0) {

                msg = {
                    name: 'pixlee:widget:loaded',
                    type: 'action',
                    source: 'parent',
                    destination: 'parent',
                    data: data
                };

                window.parent.postMessage(JSON.stringify(msg), '*');
            }

            //check to see when the widget is visible
            var IframeNode = this;
            var widgetVisibilityListener = function() {
                var visible = unguard(isWidgetVisible)(IframeNode);
                var currentWidget = widget_iframes ? widget_iframes[IframeNode.id] : false;

                if (visible && currentWidget && !currentWidget.wasSeen) {
                    msg = {
                        name: 'pixlee:widget:visible',
                        type: 'relay',
                        source: 'parent',
                        destination: 'widget',
                        data: {
                            src: IframeNode.src
                        }
                    };

                    window.parent.postMessage(JSON.stringify(msg), '*');

                    //once the event fires, we don't want to check for visibility anymore. just 1 event.
                    window.removeEventListener('scroll', widgetVisibilityListener);

                    //make sure times a million that this only fires once per widget
                    widget_iframes[IframeNode.id].wasSeen = true;
                }
            };

            //add the listener on scroll and fire it once initially AFTER listener has been attached, so that if the
            //widget is immediately in view, it doesn't double fire and can remove the listener
            window.addEventListener('scroll', widgetVisibilityListener);
            widgetVisibilityListener();
        };
        newIframe.src = options.iframe_src;
        if (_api.priority) {
            document.getElementById('pixlee_init_container').style.visibility = 'hidden';
            document.getElementById('pixlee_init_container').style.height = '0';
            document.getElementById('pixlee_init_container').appendChild(newIframe);
        } else {
            var currentContainer = document.getElementById(options.containerId);

            try {
                currentContainer.appendChild(newIframe);
            } catch (e) {
                console.warn('Pixlee: couldn\'t find any container with id ' + options.containerId);
            }

            if (_api.pixContainer === undefined) {
                _api.pixContainer = [];
            }
            _api.pixContainer.push(currentContainer);
        }

        _api.fixedWidth = options.fixedWidth;

        widget_iframes[options.iframeId] = {
            options: options,
            iframe: newIframe
        };
    });

    _api.provide('forceAttribution', function(data) {
        _api.pixContainer = _api.pixContainer || [];
        _api.pixContainer.forEach(function(container) {
            var currFrame = container.querySelector('[id*=pixlee_widget_iframe]');
            var isTargetFrame = currFrame !== null ? currFrame.src === data.src : false;
            //for multiple widgets we only wanna add one logo to each widget
            if (!isTargetFrame || container.querySelector('[id*=powered_by_pixlee]')) {
                return;
            }

            var poweredBy = document.createElement('a');
            poweredBy.id = 'powered_by_pixlee' + guid();
            poweredBy.target = '_blank';
            poweredBy.rel = 'noopener noreferrer';

            if (typeof I18n !== 'undefined' && typeof I18n.t !== 'undefined') {
                I18n.locale = data.locale;
                I18n.fallbacks = true;

                poweredBy.title = I18n.t('attribution.title');
                poweredBy.innerHTML = '<img id=\'pixlee-logo\' alt=\'\' src=\'https://assets.pixlee.com/images/logo.png\' style=\'margin-right: 3px!important;width: 8px !important;height: 8px !important;\'></img>' + I18n.t('attribution.text');
            } else {
                poweredBy.title = 'Customer photo gallery powered by Emplifi';
                poweredBy.innerHTML = '<img id=\'pixlee-logo\' alt=\'\' src=\'https://assets.pixlee.com/images/logo.png\' style=\'margin-right: 3px !important;width: 8px !important;height: 8px !important;\'></img>' + 'Powered by Emplifi';
            }

            if (data.landingPageUrl && (0 === data.landingPageUrl.indexOf('https://') || 0 === data.landingPageUrl.indexOf('http://'))) {
                poweredBy.href = data.landingPageUrl + '&utm_medium=widget-main';
            } else {
                poweredBy.href = 'https://emplifi.io/solutions/social-commerce';
            }

            var poweredByStyle = {
                opacity: '1',
                visibility: 'visible',
                height: '8px',
                width: '200px',
                display: 'flex',
                color: '#667282', // slate3
                'text-transform': 'uppercase',
                'align-items': 'center',
                'justify-content': 'center',
                'font-size': '10px',
                'font-weight': 'normal',
                'font-family': 'sofia_regular, sans-serif',
                'text-decoration': 'none',
                padding: '5px',
                margin: '0 auto',
                'line-height': '0',
                position: 'relative',
                top: 'auto',
                right: 'auto',
                bottom: 'auto',
                left: 'auto',
                '-webkit-transform': 'none',
                '-moz-transform': 'none',
                '-ms-transform': 'none',
                '-o-transform': 'none',
                transform: 'none',
                '-webkit-transition': 'none',
                '-moz-transition': 'none',
                '-ms-transition': 'none',
                '-o-transition': 'none',
                transition: 'none',
                '-webkit-animation': 'none',
                '-moz-animation': 'none',
                '-ms-animation': 'none',
                '-o-animation': 'none',
                animation: 'none',
                '-webkit-filter': 'none',
                '-moz-filter': 'none',
                '-ms-filter': 'none',
                '-o-filter': 'none',
                '-webkit-backface-visibility': 'visible',
                '-moz-backface-visibility': 'visible',
                '-ms-backface-visibility': 'visible',
                '-o-backface-visibility': 'visible',
                'backface-visibility': 'visible',
                '-webkit-box-shadow': 'none',
                '-moz-box-shadow': 'none',
                '-ms-box-shadow': 'none',
                '-o-box-shadow': 'none',
                'box-shadow': 'none',
                filter: 'none',
                'z-index': '100',
                border: 'none'
            };

            var styleProps = Object.keys(poweredByStyle);
            for (var i = 0; i < styleProps.length; i++) {
                poweredBy.style.setProperty(styleProps[i], poweredByStyle[styleProps[i]], 'important');
            }

            if (data.disablePoweredByClick) {
                poweredBy.style.setProperty('pointer-events', 'none', 'important');
            }


            if (!data.isSimple) {
                poweredBy.setAttribute('rel', 'nofollow');
            }

            var onChangeCallback = function(elem) {
                // if elem is a child element then assign parentNode
                var poweredBy = elem.target.parentNode &&
                    elem.target.parentNode.id &&
                    elem.target.parentNode.id.includes('powered_by_pixlee') ? elem.target.parentNode : elem.target;

                if (poweredBy && poweredBy.parentNode) {
                    try {
                        poweredBy.removeEventListener('DOMNodeRemoved', onChangeCallback);
                        poweredBy.parentNode.removeChild(poweredBy);
                    } catch (error) {
                        console.warn(error);
                    }
                }

                _api.forceAttribution(data);
            };

            if ('MutationObserver' in window) {
                var observer = new MutationObserver(function(mutations) {
                    mutations.forEach(onChangeCallback);
                });

                observer.observe(poweredBy, {
                    attributes: true,
                    childList: true,
                    characterData: true,
                    subtree: true
                });
            }
            container.appendChild(poweredBy);
            poweredBy.addEventListener('DOMNodeRemoved', onChangeCallback);
            _api.mutationObserverPoweredBy = onChangeCallback;
        });
    });

    //This is only called by priority widget, so anything done in here is unique to that flowg
    api.provide('renderFrame', function() {
        try {
            if (lightbox_iframe) {
                document.body.appendChild(lightbox_iframe);
            }

            var children = document.getElementById('pixlee_init_container');

            for (var widget_iframe in widget_iframes) {
                var currWidget = widget_iframes[widget_iframe];
                var targetId = currWidget.options.containerId;
                var child = children.querySelector('#' + currWidget.options.iframeId);

                var currentContainer = document.getElementById(targetId);
                currentContainer.appendChild(child);

                if (_api.pixContainer === undefined) {
                    _api.pixContainer = [];
                }
                _api.pixContainer.push(currentContainer);

                currWidget.iframe.style.visibility = '';
            }
            resizeWidget();
        } catch (e) {
            console.warn('Failed to render the widget, Probably because pixlee_init_container div is not on the page');
        }
    });
    api.provide('resizeWidget', function(fixedWidth) {
        resizeWidget(fixedWidth);
    });
    api.provide('init', function(options) {
        _api.ApiKey = options.apiKey;
        _api.priority = options.priority;

        // allow for initialization of a specified rootUrl, overriding the default
        if (options.rootUrl !== undefined) {
            _api.defaults.rootUrl = options.rootUrl + '/widget';
            _api.defaults.uploaderUrl = options.rootUrl + '/uploader';
            _api.defaults.lightboxRootUrl = options.rootUrl + '/lightbox';
            _api.defaults.socialAuthUrl = options.rootUrl + '/social_auth';
        }

        const experimentCookie = _api.getCookie('experiment_' + _api.ApiKey);
        // NB - We only want to run one experiment per account
        // Structure of this cookie - experiment_apiKey = { id: 2, group: 'treatment1' }
        // If the cookie exists, the experiment group is known
        // If it doesn't exist we might not know the group yet or it's not experimenting (based on options.AB)

        if (typeof experimentCookie === 'object' && experimentCookie !== null) {
            _api.experimentState = 'group_known';
        }

    });

    api.provide('scrollToWidget', function(scrollingContainer, widget, duration) {
        if (duration <= 0) {
            return;
        }
        var topPadding = 100;
        var difference = widget - scrollingContainer.scrollTop - topPadding;
        var perTick = difference / duration * 10;

        setTimeout(function() {
            scrollingContainer.scrollTop = scrollingContainer.scrollTop + perTick;
            if (scrollingContainer.scrollTop === widget) {
                return;
            }
            api.scrollToWidget(scrollingContainer, widget, duration - 10);
        }, 10);
    });

    // Method to call when EU_COOKIE_LAW_CONSENT is changed and we want to check it's value. EU_COOKIE_LAW_CONSENT
    // is used to track whether or not a customer on the brand's page has explicitly accepted tracking cookies. EU_COOKIE_LAW_CONSENT
    // is used in our tap2shop and landing pages and can be hooked into from the brand's website by calling Pixlee.changedCookiePolicy()
    // or Pixlee.acceptCookiePolicy
    api.provide('changedCookiePolicy', getCookieAndRelay);

    // Method to call if we want set EU_COOKIE_LAW_CONSENT to TRUE
    api.provide('acceptCookiePolicy', acceptCookiePolicy);

    // Method to call if we want set EU_COOKIE_LAW_CONSENT to FALSE
    api.provide('denyCookiePolicy', denyCookiePolicy);

    // External method to close the photo lightbox
    api.provide('closePhoto', function() {
        var message = {
            name: 'pixlee:close:lightbox',
            data: 'none',
            destination: 'lightbox',
            source: 'parent',
            type: 'action'
        };

        sendMessage(message);
    });

    api.provide('setUploaderProfile', function(profile) {
        sendMessage({
            name: 'pixlee:set:uploader:profile',
            data: profile || {},
            destination: 'all',
            source: 'parent',
            type: 'action'
        });
    });

    // Resize the mobile uploader when the address bar shows to prevent cut off
    _api.provide('mobileUploaderResize', function() {
        _api.pixleeMobileUploader.style.height = window.innerHeight + 'px';
    });

    api.provide('iFrameResize', function(opts) {
        PixleeiFrameResize(opts);
    });

    if (!window.Pixlee) {
        window.Pixlee = api;
        variableName = 'Pixlee';
    } else {
        window.PixleeWidgetsManager = api;
        variableName = 'PixleeWidgetsManager';
    }

    if (!_api.priority) {
        if (window.PixleeAsyncInit && !window.PixleeAsyncInit.hasRun) {
            window.Pixlee.hasRun = true;
            unguard(window.PixleeAsyncInit)(variableName);
        }

        if (!_api.ecomm_platform) {
            resizeWidget(_api.fixedWidth);
        }
    }

    function getFingerprintAndRelay() {
        // We want this function to handle failures gracefully since it is a dependency for analytics_events.js and lightbox_events.js
        // There can be issues importing or interpretting the fingerprint library
        // There can be issues generating the fingerprint itself
        // If for any reason this fails to get a fingerprint, we want to message back "none" as the fingerprint so that its dependents can resume their execution flow
        var message = {
            name: 'pixlee:fingerprint',
            data: 'none',
            destination: 'all',
            source: 'parent',
            type: 'relay'
        };
        if (typeof Fingerprint2 != 'undefined') {
            var fpOptions = {
                excludes: {
                    fonts: true,
                    fontsFlash: true,
                    webgl: true,
                    webglVendorAndRenderer: true,
                    plugins: true,
                    audio: true
                }
            };
            setTimeout(function() {
                try {
                    Fingerprint2.get(fpOptions, function(components) {
                        var values = components.map(function(component) {
                            return component.value;
                        });
                        var result = Fingerprint2.x64hash128(values.join(''), 31);
                        window[variableName].fingerprint = result;
                        message.data = result;
                        sendMessage(message);
                    });
                } catch (ex) {
                    // Some clients do not support Fingerprint. We know that so do not yell at Sentry too much or break the execution if that is the case
                    sendMessage(message);
                }
            }, 0);
        } else {
            sendMessage(message);
        }
    }

    function getCookieAndRelay() {
        var message = {
            name: 'pixlee:cookie',
            destination: 'all',
            source: 'parent',
            type: 'relay',
            data: _api.doesUserAcceptCookies()
        };

        sendMessage(message);
    }

    // If the customer passes { getCookieConsent:true } to the widget, they must explicitly call Pixlee.acceptCookiePolicy()
    // on their end after the user accepts cookies to be used and then we will start dropping cookies
    function acceptCookiePolicy() {
        _api.setCookieWithoutPrivacyCheck('EU_COOKIE_LAW_CONSENT', true, 30);
        getCookieAndRelay();
    }

    function denyCookiePolicy() {
        _api.setCookieWithoutPrivacyCheck('EU_COOKIE_LAW_CONSENT', false, 30);
        // Also delete the pixlee_analytics_cookie if one existed before the user denied cookies
        _api.setCookieWithoutPrivacyCheck('pixlee_analytics_cookie', {}, 0);

        getCookieAndRelay();
    }

    function sendMessage(message) {
        var destination = message.destination;
        var targetFrames;

        //decide what our target frame is
        if (destination === 'widget') {
            targetFrames = document.querySelectorAll('iframe[id*=pixlee_widget_iframe]');
        } else if (destination === 'lightbox') {
            if (lightbox_iframe !== 'undefined') {
                targetFrames = [lightbox_iframe];
            }
        } else if (destination === 'all') {
            targetFrames = document.querySelectorAll('iframe[id*=pixlee]');
        } else {
            console.log('unknown target frame'); //for dev purposes, catch typos and trace errors etc.
        }
        //let all of the widgets on the page know what we want to do. relay events are safe to pass through and this
        //adds very little overhead since there's hardly ever multiple widgets on a page
        try {
            for (var i = 0; i < targetFrames.length; i++) {
                targetFrames[i].contentWindow.postMessage(JSON.stringify(message), '*');
            }
        } catch (e) {
            //if a frame fails to be fetched it means it wasn't properly initialized. re-initialize it.
            if ('PixleeAsyncInit' in window && typeof window.PixleeAsyncInit === 'function') {
                if (destination === 'widget') {
                    window.PixleeAsyncInit();
                } else if (destination === 'lightbox' && message.source === 'widget') {
                    _api.createLightboxContainer(lightbox_options, null);
                }
            } else {
                console.warn('Pixlee: widget iframe is not initialized, please check your embed code');
            }
        }
    }

    function receiveMessage(event) {
        var eventData;
        var msg;
        var i = 0;

        /*********************************************************************************************/
        /* Identify whether this is one of our messages, and if so, turn it into the expected format */
        /*********************************************************************************************/
        if (event.data) {
            try {
                eventData = JSON.parse(event.data);
            } catch (error) {
                // Some other way of sending data, ignore
                return;
            }
            //only capture from our domain
            if (event.origin.indexOf('//photos.pixlee.test') === -1 && event.origin.indexOf('pxlecdn.com') === -1 && event.origin.indexOf('pixlee.co') === -1 &&
                (eventData.name && eventData.name.indexOf('pixlee:') !== 0)) {
                return;
            }
        } else {
            return;
        }

        /*******************************************************************************************************/
        /* SUBSCRIBED EVENTS are re-emmitted under an external facing name so customers can interact with them */
        /*******************************************************************************************************/
        if (eventData.name && _api.subscribedEvents && _api.subscribedEvents.indexOf(eventData.name) !== -1) {
            var emitMessage = true;
            msg = {};

            //map back to the customer facing event
            for (var key in _api.eventMappings) {
                if (_api.eventMappings[key] === eventData.name) {
                    msg.eventName = key;
                    break;
                }
            }

            //special pre-emit changes go here for each event
            if (eventData.data) {
                //sanitize event data as needed and then re-emmit to customer
                if (msg.eventName === 'photoOpened') {
                    //return the info for the current photo only
                    msg.data = JSON.parse(eventData.data.modelData)[eventData.data.indexToOpen];
                    msg.data.photoIndex = eventData.data.indexToOpen;
                } else if (msg.eventName === 'photoChanged' && eventData.data.initialOpen) {
                    //if it's the first time the lightbox is opening, then don't emit a change event
                    emitMessage = false;
                } else {
                    msg.data = eventData.data;
                }
            }

            //if we still want to emit after the previous step, do it
            if (emitMessage) {
                window.parent.postMessage(JSON.stringify(msg), '*');
            }
        }

        /*********************************************************************************/
        /* ACTION events require some action to be taken from the parent page (aka here) */
        /*********************************************************************************/
        if (eventData.type && eventData.type === 'action') {
            //variables to be used in multiple places
            var id;
            var currentWidget;
            var frame;

            //Take the appropriate action
            if (eventData.name === 'pixlee:close:widget') {
                var frames = document.getElementsByTagName('iframe');
                for (i = 0; i < frames.length; i++) {
                    if (frames[i].id !== (_api.defaults.lightboxId) && frames[i].contentWindow === event.source) {
                        frames[i].parentNode.removeChild(frames[i]);
                        break;
                    }
                }
            } else if (eventData.name && eventData.name === 'pixlee:show:lightbox') {
                // Hide all background content from screen readers by walking
                // up from the lightbox iframe to <body>, marking every sibling
                // at each level as aria-hidden. This ensures only the lightbox
                // iframe remains accessible.
                var el = lightbox_iframe;
                while (el && el !== document.body) {
                    var parent = el.parentNode;
                    if (parent) {
                        for (var s = 0; s < parent.children.length; s++) {
                            var sibling = parent.children[s];
                            if (sibling !== el && sibling.tagName !== 'SCRIPT' && sibling.tagName !== 'LINK' && sibling.tagName !== 'STYLE') {
                                sibling.setAttribute('aria-hidden', 'true');
                                sibling.setAttribute('data-lightbox-hidden', 'true');
                            }
                        }
                    }
                    el = parent;
                }

                // Timeout to fix scrolling to footer on lightbox close
                var timeout = iOSChromeCheck() ? 10 : 0;
                setTimeout(function() {
                    lightbox_iframe.style.display = 'block';
                    lightbox_iframe.style.webkitTransform = 'translatez(0)';
                    lightbox_iframe.style.position = 'fixed';
                    lightbox_iframe.style.zIndex = '2147483647';
                    lightbox_iframe.removeAttribute('aria-hidden');

                    removeFlickerScreen();
                }, timeout);
            } else if (eventData.name && eventData.name === 'pixlee:hide:lightbox') {
                // Restore all elements hidden when the lightbox opened
                var hiddenEls = document.querySelectorAll('[data-lightbox-hidden]');
                for (var h = 0; h < hiddenEls.length; h++) {
                    hiddenEls[h].removeAttribute('aria-hidden');
                    hiddenEls[h].removeAttribute('data-lightbox-hidden');
                }

                // Put focus back on the widget iframe that triggered the lightbox
                for (id in widget_iframes) {
                    frame = document.getElementById(id);
                    if (frame) {
                        frame.focus();
                        break;
                    }
                }

                setTimeout(function() {
                    lightbox_iframe.style.display = 'none';
                    lightbox_iframe.setAttribute('aria-hidden', 'true');
                    lightbox_iframe.blur();
                }, 0);

                if (iOSSafariCheck()) {
                    removeFlickerScreen();
                }
                _api.changeUrl(_api.removeParam('pixlee_album_photo_id', window.location.href));
            } else if (eventData.name && eventData.name === 'pixlee:show:uploader') {
                for (id in widget_iframes) {
                    // hide widget from screen reader
                    frame = document.getElementById(id);
                    if (frame) {
                        frame.setAttribute('aria-hidden', true);
                    }
                }
                // hide lightbox from screen reader
                lightbox_iframe.setAttribute('aria-hidden', true);

                if (eventData.data && eventData.data.designEditorDevice) {
                    // faking user agent
                    _api.changeUserAgent(eventData.data.designEditorDevice);
                    if (uploader_iframe) {
                        uploader_iframe.className = eventData.data.designEditorDevice;
                    }
                }
                _api.createLightboxUploader(eventData.data);
            } else if (eventData.name && eventData.name === 'pixlee:show:social:connect') {
                _api.createSocialAuth(widget_iframes[eventData.data.widgetId].options);
            } else if (eventData.name && eventData.name === 'pixlee:change:lightbox:image') {
                _api.changeUrl(_api.updateURLParameter(window.location.href, 'pixlee_album_photo_id', eventData.data.id));
            } else if (eventData.name && eventData.name === 'pixlee:remove:url:param') {
                _api.changeUrl(_api.removeParam('pixlee_album_photo_id', window.location.href));
            } else if (eventData.name && eventData.name === 'pixlee:create:cookie') {
                if (eventData.data) {
                    _api.createCookie(eventData.data);
                    _api.tagByEmail();
                }
            } else if (eventData.name && eventData.name === 'pixlee:opened:photo') {
                if (eventData.data) {
                    _api.openedPhoto(eventData.data);
                }
            } else if (eventData.name && eventData.name === 'pixlee:interacted') {
                if (eventData.data) {
                    _api.interacted(eventData.data);
                }
            } else if (eventData.name && eventData.name === 'pixlee:close:uploader') {
                for (id in widget_iframes) {
                    // show widget for screen reader
                    frame = document.getElementById(id);
                    if (frame) {
                        frame.removeAttribute('aria-hidden');
                    }
                }
                // hide lightbox from screen reader
                if (lightbox_iframe) {
                    lightbox_iframe.setAttribute('aria-hidden', true);
                }

                if (uploader_iframe && uploader_iframe.parentNode) {
                    if (mobileCheck()) {
                        window.removeEventListener('resize', _api.mobileUploaderResize);
                    }

                    setTimeout(function() {
                        uploader_iframe.parentNode.removeChild(uploader_iframe);
                    }, 0);
                }
            } else if (eventData.name && eventData.name === 'pixlee:interactive:widget:resize') {
                var originalStyle;
                var originalPos;

                for (id in widget_iframes) {
                    currentWidget = widget_iframes[id].iframe;

                    //only alter the widget which initiated this event
                    if (currentWidget.contentWindow === event.source) {
                        if (eventData.data.active) {
                            originalStyle = currentWidget.getAttribute('style');
                            originalPos = window.scrollY || 0;

                            if (!eventData.data.isPreview) {
                                currentWidget.setAttribute('style', 'top: 0px; left: 0px; width: 100%; height: 100%; padding: 0px; margin: 0px; position: fixed; z-index:2147483647; border: none; overflow: hidden;');
                            }

                            _api.setCookie('pixlee_widget_style', originalStyle, 30);
                            _api.setCookie('pixlee_widget_scroll_pos', originalPos, 30);
                        } else {
                            originalStyle = _api.getCookie('pixlee_widget_style');
                            originalPos = _api.getCookie('pixlee_widget_scroll_pos');

                            if (originalStyle) {
                                currentWidget.setAttribute('style', originalStyle);
                            } else {
                                currentWidget.setAttribute('style', 'border: none; overflow: hidden;');
                            }

                            if (originalPos) {
                                window.scrollTo(window.scrollX, originalPos);
                            }
                        }
                    }
                }
            } else if (eventData.name && eventData.name === 'pixlee:interactive:widget:mobile:scroll:top:fix') {
                if (iOSSafariCheck()) {
                    //create a temporary white background to prevent the scrolling from causing a visual flicker
                    createFlickerScreen();
                }
            } else if (eventData.name && eventData.name === 'pixlee:interactive:widget:mobile:horizontal') {
                for (id in widget_iframes) {
                    currentWidget = widget_iframes[id].iframe;

                    //only alter the widget which initiated this event
                    if (currentWidget.contentWindow === event.source) {
                        currentWidget.style.width = screen.width + 'px';
                        currentWidget.style.maxWidth = screen.width + 'px';
                    }
                }
            } else if (eventData.name && eventData.name === 'pixlee:widget:size:fix') {
                var iOS = /iPad|iPhone|iPod/.test(navigator.platform);
                var standalone = document.location.href.indexOf('standalone') !== -1;
                var currentOptions = eventData.data;

                for (id in widget_iframes) {
                    var specifiedOptions = widget_iframes[id].options;
                    var widgetIframe = widget_iframes[id].iframe;

                    //make sure we're only applying this if it's the specified widget, convert message to compare int to int
                    if (specifiedOptions.widgetId && +specifiedOptions.widgetId === currentOptions.widgetId) {

                        if (iOS && !standalone && currentOptions.widgetType !== 'tap2shop' && currentOptions.widgetType !== 'photowall' && currentOptions.widgetType !== 'mosaic' && currentOptions.widgetType !== 'mosaic_v2' && currentOptions.widgetType !== 'single') {
                            widgetIframe.width = '1px';
                        } else {
                            widgetIframe.width = '100%';
                        }
                    }
                }
            } else if (eventData.name && eventData.name === 'pixlee:open:lightbox') {
                if (iOSSafariCheck()) {
                    //create a temporary white background to prevent the scrolling from causing a visual flicker
                    createFlickerScreen();
                }
            } else if (eventData.name && eventData.name === 'pixlee:hide:flicker:screen') {
                removeFlickerScreen();
            } else if (eventData.name && eventData.name === 'pixlee:generate:attribution:link') {
                _api.forceAttribution(eventData.data);
            } else if (eventData.name && eventData.name === 'pixlee:get:parent:protocol') {
                eventData.data.protocol = window.location.protocol;
            } else if (eventData.name && eventData.name === 'pixlee:get:fingerprint:from:parent') {
                // Either Fingeprint is ready or it might not be ready
                if (window[variableName].fingerprint) {
                    var message = {
                        name: 'pixlee:fingerprint',
                        data: window[variableName].fingerprint,
                        destination: 'all',
                        source: 'parent',
                        type: 'relay'
                    };
                    sendMessage(message);
                } else {
                    if (document.readyState === 'complete') {
                        getFingerprintAndRelay();
                    } else {
                        window.addEventListener('load', getFingerprintAndRelay);
                    }
                }

            } else if (eventData.name && eventData.name === 'pixlee:log:to:sentry') {
                window.pixSentry.captureMessage(eventData.data.messageText, eventData.data.messageExtraFields);

            } else if (eventData.name && eventData.name === 'pixlee:experiment:info') {
                if (eventData.data.experimenting) {
                    var experimentCookie = {};
                    experimentCookie.id = eventData.data.experiment_id;
                    experimentCookie.group = eventData.data.experiment_group;
                    _api.setCookie('experiment_' + _api.ApiKey, experimentCookie, 30);
                }
            } else if (eventData.name && eventData.name === 'pixlee:hide:widget') {
                var frames = document.getElementsByTagName('iframe');
                for (i = 0; i < frames.length; i++) {
                    if (frames[i].id !== (_api.defaults.lightboxId) && frames[i].contentWindow === event.source) {
                        frames[i].parentNode.style.display = 'none';
                        break;
                    }
                }
            } else if (eventData.name && eventData.name === 'pixlee:get:cookie:from:parent') {
                if (document.readyState === 'complete') {
                    getCookieAndRelay();
                } else {
                    window.addEventListener('load', getCookieAndRelay);
                }
            } else if (eventData.name && eventData.name === 'pixlee:save:votes') {
                var pixleeLikes = eventData.data.pixlee_likes;
                _api.setCookie('pixlee_likes', pixleeLikes, 30);
                // If the page persisted from cache, reload the widget and lightbox to fix js issues
            } else if (eventData.name && eventData.name === 'pixlee:page:persisted') {
                var albumPhotoId = eventData.data.pixleeAlbumPhotoId;
                if (albumPhotoId) {
                    _api.setLightboxPhotoId(albumPhotoId);
                }
            } else if (eventData.name && eventData.name === 'pixlee:share:to:social') {
                // Communicates back to the widget with the full window URL to properly share to social media and link back
                // to the embedded widget
                var message = {
                    name: 'pixlee:trigger:share:to:social',
                    data: {
                        photoJson: eventData.data.photoJson,
                        source: eventData.data.source,
                        url: window.location.href,
                    },
                    destination: 'widget',
                    source: 'parent',
                    type: 'action'
                };

                sendMessage(message);
            }

            /***************************************************************************************************************/
            /* If this event's final destination is NOT the parent, then turn it into a relay so it can be sent on its way */
            /***************************************************************************************************************/
            if (eventData.destination !== 'parent') {
                eventData.type = 'relay';
            }
        }

        /**************************************************************************************************/
        /* RELAY events transfer info from one frame to the other (lightbox/widget/uploader/social login) */
        /**************************************************************************************************/
        if (eventData.type && eventData.type === 'relay') {
            sendMessage(eventData);
        }
    }
    try {
        window.addEventListener('message', function(e) {
            unguard(receiveMessage)(e);
        }, false);
    } catch (e) {
        console.warn('Pixlee: couldn"t find any container with id pixlee_container');
    }
    if (!Array.prototype.forEach) {
        Array.prototype.forEach = function(fun /*, thisArg */) {
            'use strict';
            if (this === void 0 || this === null || typeof fun !== 'function') {
                throw new TypeError();
            }

            var
                t = Object(this),
                len = t.length >>> 0,
                thisArg = arguments.length >= 2 ? arguments[1] : void 0;

            for (var i = 0; i < len; i++) {
                if (i in t) {
                    fun.call(thisArg, t[i], i, t);
                }
            }
        };
    }

    // Register as a named AMD module if users so choose to load in this manner
    if (typeof define === 'function' && define.amd) {
        define('pixlee', [], function() {
            return api;
        });
    }
})();
